<template>
  <router-view v-slot="{ Component, route }">
    <transition v-bind:name="route.meta.transition">
      <keep-alive v-bind:include="/KahiMap|KahiList/">
        <component
          v-bind:is="Component"
          v-bind:key="route.meta.componentKey"
        ></component>
      </keep-alive>
    </transition>
  </router-view>
</template>

<script lang="ts" src="./App.ts"></script>
<style lang="scss" src="./App.scss"></style>
